// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"50329694","341":"43ad6b17","453":"670e15c7","520":"a10be285","598":"9134a065","722":"ae5fad1b","877":"b8d9cd64"}[chunkId] + ".chunk.js";
};